export default "<app-nica-tabs name=\"tabs2\"></app-nica-tabs>\r\n"